import { SETTINGS_PATH } from 'cpmCarparks/navigation';

module.exports = {
  path: SETTINGS_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/NewSettings/NewSettings'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/routes/show/routes/newSettings/index.js